import React from 'react'

// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
const AuthContext = React.createContext()
const { Provider, Consumer } = AuthContext

export { AuthContext, Provider as AuthProvider, Consumer as AuthConsumer }
